var $fd37a27baae493e8$exports = {};
$fd37a27baae493e8$exports = {
    "removeButtonLabel": `Odstrani`,
    "removeDescription": `Pritisnite Delete, da odstranite oznako.`
};


export {$fd37a27baae493e8$exports as default};
//# sourceMappingURL=sl-SI.module.js.map
